import React from 'react';

import './App.css'
import AppContainer from "./components/AppContainer";


function App() {
    return (
        <div className="app-content">
            <AppContainer/>
        </div>
    );
}

export default App;
